import React, { useMemo, useState } from "react";
import PageHero from "../components/shared/PageHero";
import CategoryPills from "../components/shared/CategoryPills";
import FeaturedPost from "../components/blog/FeaturedPost";
import ArticleGrid from "../components/blog/ArticleGrid";
import Newsletter from "../components/Newsletter";
import { articles, blogCategories, getArticleBySlug } from "../articlesData";

const blogArticles = articles.filter((a) => a.section === "blog");
const featured = getArticleBySlug("new-wave-lagos-fashion");

export default function BlogNews() {
  const [activeCategory, setActiveCategory] = useState("All");

  const filtered = useMemo(() => {
    if (activeCategory === "All") return blogArticles;
    return blogArticles.filter((a) => a.tag === activeCategory);
  }, [activeCategory]);

  return (
    <>
      <PageHero
        eyebrow="The Wire"
        title="Blog & News"
        subtitle="Breaking music news, exclusive interviews, industry insight, and the stories shaping culture right now."
      />

      <section className="mu-section pb-0">
        <div className="container">
          <CategoryPills categories={blogCategories} active={activeCategory} onSelect={setActiveCategory} />
        </div>
      </section>

      <FeaturedPost article={featured} />
      <ArticleGrid title="Latest Posts" articles={filtered} />
      <Newsletter />
    </>
  );
}
